import { useUser } from "@/context/UserContext";
import { getCompletedChallenges } from "@/services/challenges";
import { useMemo } from "react";
import { useQuery } from "react-query";

export function useGetCompletedChallenges() {
  const { userInfo } = useUser();

  const { data, isLoading, isFetching } = useQuery(
    "completed-challenges",
    () => getCompletedChallenges(),
    { enabled: !!userInfo?.id }
  );

  const isCompletedChallenges =
    data?.completedChallenges === data?.totalChallenges;

  const submittedChallengesCount = useMemo(() => {
    if (isLoading) return 0;
    return data?.submittedChallenges ?? data?.completedChallenges ?? 0;
  }, [isLoading, data]);

  const completedChallengesCount = useMemo(() => {
    if (isLoading) return 0;
    return data?.completedChallenges ?? 0;
  }, [isLoading, data]);

  return {
    data,
    submittedChallengesCount,
    completedChallengesCount,
    isCompletedChallenges,
    isLoading: isLoading || isFetching,
  };
}
